import { CSSTransition } from 'react-transition-group';
import { Box } from 'v1/ui';

export function AppearFadeInTransition({
  children,
  delay = 0,
  duration = 500,
  timing = 'ease-in',
}: {
  children: React.ReactNode;
  delay?: number;
  duration?: number;
  timing?: string;
}) {
  return (
    <Box
      sx={{
        '@media(prefers-reduced-motion: no-preference)': {
          '.fade-in.appear-active': {
            opacity: 0,
          },
          '.fade-in.appear-done': {
            opacity: 1,
            transition: `opacity ${duration}ms ${timing}`,
            transitionDelay: `${delay}ms`,
          },
        },
      }}
    >
      <CSSTransition appear={true} in={true} className="fade-in" timeout={0}>
        {children}
      </CSSTransition>
    </Box>
  );
}

export function CardAppearTransition({
  children,
  index,
}: {
  children: React.ReactNode;
  index: number;
}) {
  return (
    <Box
      sx={{
        '@media(prefers-reduced-motion: no-preference)': {
          '.card-appear.appear-active': {
            opacity: 0,
            transform: 'translateY(300px)',
          },
          '.card-appear.appear-done': {
            opacity: 1,
            transform: 'translateY(0)',
            transition: `transform ${appearTransitionTime}ms ease-out, opacity ${appearTransitionTime}ms ease-in`,
            transitionDelay: `${getTransitionDelay(index)}ms`,
          },
        },
      }}
    >
      <CSSTransition
        appear={true}
        in={true}
        className="card-appear"
        timeout={0}
      >
        {children}
      </CSSTransition>
    </Box>
  );
}

const appearTransitionTime = 600;

function getTransitionDelay(index: number) {
  return ((index * index) / 6) * 50;
}

export function getCardTransitionTime(numberOfCards: number) {
  return getTransitionDelay(numberOfCards) + appearTransitionTime;
}
